import AddPageModal from "../../components/AddPage/AddPage";
import {useEffect, useState} from "react";
import http from "../../http";
import {message} from "antd";
import {useSelector} from "react-redux";


const RoleAddPage=({visible, onClose, onSuccessSubmit, onErrorSubmit, edit, editItem, modalSize, reload})=>{
    const [initialValues, setInitialValues] = useState({})
    const auth = useSelector((state) => state.auth);
    const config = {
        addUrl: '/api/v1/auth/roles/add/',
        editUrl: edit ? `/api/v1/auth/roles/${editItem?.id}/edit/` : '',
        dataUrl: edit? `/api/v1/auth/roles/${editItem?.id}/` : '',
        pageTitle: !edit ? 'Role Add Page' : `Edit ${editItem?.name || ''}`,
        colNo: 2,
        cancelButtonText: 'Cancel',
        saveButtonText: !edit ? 'Save' : 'Edit',
        addSuccessMessage: !edit ? 'Role Added Successfully' : 'ROle Updated Successfully',
        modalSize: modalSize || 300,
        fields: [
            {
                name: 'name',
                label: 'Role Name',
                placeholder: 'Enter Role Name',
                isRequired: false,
                requiredMessage: '',
                type: 'input',
                colNo: 1,
                order: 2
            },
            {
                name: 'tenant',
                label: 'Constructor',
                placeholder: 'Enter Constructor',
                isRequired: false,
                requiredMessage: 'Constructor Selection Mandatory',
                type: 'select',
                extraProps:{
                    url: '/api/v1/tenants/combo/'
                },
                colNo: 1,
                order: 1,
                hidden: !auth.is_superuser
            },
        ]
    }


    useEffect(()=>{
        setInitialValues({});
        if(editItem){
            let dataUrl = `/api/v1/auth/roles/${editItem?.id}/`;
            http.get(dataUrl).then((resp)=>{
                setInitialValues(resp.data);
            }).catch((err)=>{
                message.error('Loading Data Failed')
            })
        }
    }, [editItem])

    return <AddPageModal config={config} visible={visible} onClose={onClose} onSuccessSubmit={onSuccessSubmit} onErrorSubmit={onErrorSubmit} edit={edit} initialValues={initialValues}/>

}

export default RoleAddPage;